var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      type: "card",
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabsChange
    }
  }, [_vm._l(_vm.tabs, function (tab) {
    return [_vm.isAuth(tab.auth) ? _c("a-tab-pane", {
      key: tab.key,
      attrs: {
        tab: _vm.$t(tab.tab)
      }
    }, [_c("a-collapse", _vm._l(_vm.collapses, function (item) {
      return _c("a-collapse-panel", {
        key: item.key,
        attrs: {
          header: _vm.$t(item.title)
        }
      }, [tab.key === "3" || tab.key === "4" ? [_vm.datas ? _c("makePageFormModel", {
        attrs: {
          type: tab.key,
          language: item.key,
          item: _vm.datas
        }
      }) : _vm._e()] : _vm._e(), tab.key === "5" ? [_vm.datas ? _c("cookieFormModel", {
        attrs: {
          type: tab.key,
          language: item.key,
          item: _vm.datas
        }
      }) : _vm._e()] : _vm._e()], 2);
    }), 1)], 1) : _vm._e()];
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };